import { Cache } from 'aws-amplify';

export function getItem(key) {

	return Cache.getItem(key);
}

/**
 * 
 * @param {string} key 
 * @param {string} value 
 * @param {number} expires The expiration time of the cache item in milliseconds. 
 * @param {number} priority 
 * @returns string|null
 */
export function setItem(key, value, expires) {

	return Cache.setItem(key, value, { expires });
}

export function removeCache(key) {

	return Cache.removeItem(key);
}

export function clearCache() {

	return Cache.clear();
}

export function getFederatedInfo(){
	return localStorage.getItem("aws-amplify-federatedInfo");
}